import { http } from "./http";

export interface ExportFinding {
  file: string;
  term: string;
  line: number;
  excerpt: string;
}

export interface ExportReport {
  scan: {
    ok: boolean;
    blocking: ExportFinding[];
    warnings: ExportFinding[];
    files_scanned: number;
  };
  required_files: Record<string, boolean>;
  excluded: {
    directories: string[];
    files: string[];
    extensions: string[];
  };
}

export const exportService = {
  /** Relatório de portabilidade: o projeto roda sem o Builder? */
  inspect: (projectId: string) => http.get<ExportReport>(`/projects/${projectId}/export`),

  /** URL do download do .zip (autenticado por cookie de sessão). */
  downloadUrl: (projectId: string) =>
    `${import.meta.env.VITE_API_URL ?? "/api"}/projects/${projectId}/export/download`,
};
